import type { StyleRule } from '@archipro-design/aria';
import { popupContentSlotClassNames } from '@archipro-design/aria';
import { popupContentClassName } from '@archipro-design/aria';
import { drawerSlotClassNames } from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const DrawerContent: StyleRule = ({ theme }) => ({
    width: '100vw',
    maxWidth: '100vw',
    padding: theme.siteVariables.spaces['space-16'],
});
export const Drawer: StyleRule = () => ({
    ['&.' + popupContentClassName]: {
        paddingBottom: 0,
        height: '100vh',
        ['& .' + popupContentSlotClassNames.content]: {
            ['& .' + drawerSlotClassNames.content]: {
                height: 'fit-content',
                position: 'sticky', // Fix address bar covering content on Safari mobile
                bottom: 0,
            },
        },
    },
});

export const Header: StyleRule = ({ theme }) => ({
    alignItems: 'center',
    minHeight: pxToRem(61),
    marginTop: pxToRem(1),
    borderBottom: `1px solid ${theme.siteVariables.colors.charcoal[250]}`,
    padding: pxArrayToRem([0, 8]),
    columnGap: theme.siteVariables.spaces['space-8'],
});

export const ItemContainer: StyleRule = () => ({
    margin: 0,
    padding: pxArrayToRem([24, 0, 32, 0]),
});

export const BtnViewCart: StyleRule = () => ({
    ['& span.' + svgIconClassName]: {
        margin: pxArrayToRem([0, 3]),
        width: pxToRem(11),
        height: pxToRem(11),
    },
});
